export default __webpack_public_path__ + "static/media/card__image__bg--one.51b1f02b.jpg";